module.exports = __webpack_public_path__ + "static/media/rick_morty.f055a402.png";